import React from "react"
import types from "prop-types"
import { ScheduledTaskReportExportContextProvider } from "contexts/ScheduledTaskReportExportContext"
import { formSlugOptionShape, newTaskReportExportTaskReportShape } from "utils/propTypeShapes"
import ScheduledTaskReportExportForm from "views/ScheduledTaskReportExportForm"

const NewScheduledTaskReportExport = ({ submittableForms, taskReport }) => (
  <ScheduledTaskReportExportContextProvider submittableForms={submittableForms} taskReport={taskReport}>
    <ScheduledTaskReportExportForm />
  </ScheduledTaskReportExportContextProvider>
)

NewScheduledTaskReportExport.propTypes = {
  submittableForms: types.arrayOf(formSlugOptionShape).isRequired,
  taskReport: newTaskReportExportTaskReportShape.isRequired,
}

export default NewScheduledTaskReportExport
